<svg class="progress-icon" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
  <g class="tick-icon" stroke-width="2" stroke="#009919" fill="none" transform="translate(1, 1.2)">
    <path #tickOutlinePath id="tick-outline-path"
          d="M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z" opacity="0"/>
    <path #tickPath id="tick-path" d="M6.173 16.252l5.722 4.228 9.22-12.69" opacity="0"/>
  </g>
</svg>
